"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _tailwindMerge = require("tailwind-merge");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faSpinner = require("@fortawesome/pro-regular-svg-icons/faSpinner");

var defaultVariants = _interopRequireWildcard(require("./variants"));

var _excluded = ["variantColor", "variantStyle", "variants", "loading", "className", "children", "href"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = function Button(_ref) {
  var _variants$variantColo, _variants$variantColo2, _variants$variantColo3;

  var _ref$variantColor = _ref.variantColor,
      variantColor = _ref$variantColor === void 0 ? 'primary' : _ref$variantColor,
      _ref$variantStyle = _ref.variantStyle,
      variantStyle = _ref$variantStyle === void 0 ? 'solid' : _ref$variantStyle,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? defaultVariants : _ref$variants,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      href = _ref.href,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var variantClassName = '';

  if (variants !== null && variants !== void 0 && variants[variantColor]) {
    switch (variantStyle) {
      case 'outline':
        variantClassName = ((_variants$variantColo = variants[variantColor]) === null || _variants$variantColo === void 0 ? void 0 : _variants$variantColo.outlineClasses) || '';
        break;

      case 'link':
        variantClassName = ((_variants$variantColo2 = variants[variantColor]) === null || _variants$variantColo2 === void 0 ? void 0 : _variants$variantColo2.linkClasses) || '';
        break;

      default:
        variantClassName = ((_variants$variantColo3 = variants[variantColor]) === null || _variants$variantColo3 === void 0 ? void 0 : _variants$variantColo3.solidClasses) || '';
    }
  }

  return href ? /*#__PURE__*/_react["default"].createElement("a", _extends({
    type: "button",
    href: href,
    className: "".concat((0, _tailwindMerge.twMerge)("".concat(variantClassName, " ").concat(className)))
  }, restProps), children) : /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: "".concat((0, _tailwindMerge.twMerge)("".concat(variantClassName, " ").concat(className)))
  }, restProps), loading ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faSpinner.faSpinner,
    className: "fa-spin"
  }) : children);
};

exports.Button = Button;
var _default = Button;
exports["default"] = _default;